// import { useEffect, useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import '../css/navbar.css';
// import Logo from '../assets/logo.png';


// export default function Navbar() {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const pathname = useLocation().pathname;

//   useEffect(() => {
//     const navbar = document.querySelector('.navbar');

//     function toggleStickyNavbar() {
//       if (navbar) {
//         if (window.scrollY > 50) {
//           navbar.classList.add('nav-sticky');
//         } else {
//           navbar.classList.remove('nav-sticky');
//         }
//       }
//     }

//     window.addEventListener('scroll', toggleStickyNavbar);

//     return () => {
//       window.removeEventListener('scroll', toggleStickyNavbar);
//     };
//   }, []);

//   return (
//     <div className="navbar navbar-expand-lg bg-dark navbar-dark">
//       <div className="container-fluid">
//         {/* Brand Logo */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={Logo} alt="Logo" className="logo me-2" />
//         </Link>

//         {/* Toggler Button */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarCollapse"
//           aria-controls="navbarCollapse"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//          <div className="collapse navbar-collapse justify-content-end" id="navbarCollapse">
//       <ul className="navbar-nav">
//         <li
//           className="nav-item dropdown"
//           onMouseEnter={() => setDropdownOpen(true)}  // Open dropdown when hovering over parent
//           // Close dropdown when leaving the parent
//         >
//           <span
//             className={`nav-link dropdown-toggle ${dropdownOpen ? 'show' : ''}`}
//             role="button"
//             onClick={() => setDropdownOpen(!dropdownOpen)} // Optional: Allow toggle with click
//           >
//             Menu
//           </span>
//           <ul
//             className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
//             onMouseEnter={() => setDropdownOpen(true)}  // Keep open when hovering over menu items
//             onMouseLeave={() => setDropdownOpen(false)}  // Close when leaving the menu
//           >
//             <li>
//               <Link to="/" className={`dropdown-item ${pathname === "/" ? "active" : ""}`}>
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className={`dropdown-item ${pathname === "/about" ? "active" : ""}`}>
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className={`dropdown-item ${pathname === "/contact" ? "active" : ""}`}>
//                 Contact
//               </Link>
//             </li>
//           </ul>
//         </li>
//       </ul>
//     </div>


//       </div>
//     </div>
//   );
// }
// import { useEffect, useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import '../css/navbar.css';
// import Logo from '../assets/logo.png';

// export default function Navbar() {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const pathname = useLocation().pathname;

//   useEffect(() => {
//     const navbar = document.querySelector('.navbar');

//     function toggleStickyNavbar() {
//       if (navbar) {
//         if (window.scrollY > 50) {
//           navbar.classList.add('nav-sticky');
//         } else {
//           navbar.classList.remove('nav-sticky');
//         }
//       }
//     }

//     window.addEventListener('scroll', toggleStickyNavbar);

//     return () => {
//       window.removeEventListener('scroll', toggleStickyNavbar);
//     };
//   }, []);

//   return (
//     <div className="navbar navbar-expand-lg navbar-dark">
//       <div className="container-fluid">
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={Logo} alt="Logo" className="logo me-2" />
//         </Link>

//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarCollapse"
//           aria-controls="navbarCollapse"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         <div className="collapse navbar-collapse justify-content-end" id="navbarCollapse">
//           <ul className="navbar-nav">
//             <li className="nav-item dropdown">
//               <span
//                 className={`nav-link dropdown-toggle ${dropdownOpen ? 'show' : ''}`}
//                 role="button"
//                 onClick={() => setDropdownOpen(!dropdownOpen)}
//               >
//                 Menu
//               </span>
//               <ul
//                 className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
//                 onMouseEnter={() => setDropdownOpen(true)}
//                 // onMouseLeave={() => setDropdownOpen(false)}
//               >
//                 <li>
//                   <Link to="/" className={`dropdown-item ${pathname === '/' ? 'active' : ''}`}>
//                     Home
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/about" className={`dropdown-item ${pathname === '/about' ? 'active' : ''}`}>
//                     About Us
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/contact" className={`dropdown-item ${pathname === '/contact' ? 'active' : ''}`}>
//                     Contact
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }
import { useState, useRef } from 'react';
import { Link, useLocation , useNavigate} from 'react-router-dom';
import '../css/navbar.css';
import Logo from '../assets/logo.png';


export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  const handleMouseEnter = () => setDropdownOpen(true);

  const handleMouseLeave = (e) => {
    // Check if relatedTarget exists and is a valid Node
    if (
      !dropdownRef.current ||
      !e.relatedTarget ||
      !(e.relatedTarget instanceof Node) || 
      !dropdownRef.current.contains(e.relatedTarget)
    ) {
      setDropdownOpen(false);
    }
  };
  const handlePartnerClick = (e) => {
    e.preventDefault();
    if (pathname === "/") {
      window.location.hash = "partners"; // Scroll to funds section
    } else {
      navigate("/#partners"); // Navigate to home with hash
    }
  };


  return (
    <div className="navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <img src={Logo} alt="Logo" className="logo me-2" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarCollapse">
          <ul className="navbar-nav">
            <li
              className="nav-item dropdown"
              ref={dropdownRef}
              onMouseEnter={handleMouseEnter}
            >
              <span
                className={`nav-link dropdown-toggle ${dropdownOpen ? 'show' : ''}`}
                role="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Menu
              </span>
              <ul
                className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
                onMouseLeave={handleMouseLeave}
              >
                <li>
                  <Link
                    to="/"
                    className={`dropdown-item ${pathname === '/' ? 'active' : ''}`}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className={`dropdown-item ${pathname === '/about' ? 'active' : ''}`}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className={`dropdown-item ${pathname === '/contact' ? 'active' : ''}`}
                  >
                    Contact
                  </Link>
                </li>
                 <li>
                  <Link
                    to="/event"
                    className={`dropdown-item ${pathname === '/event' ? 'active' : ''}`}
                  >
                    Events
                  </Link>
                </li>
                <li>
                <a
                    href="/#partners"
                    className="dropdown-item"
                    onClick={handlePartnerClick}
                  >
                    Partners
                  </a>
                    Partners
                
                </li>
                 
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
